export default __webpack_public_path__ + "static/media/lose.c491ab7e.png";